var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"balance-panel"},[_c('BalanceContainer',{attrs:{"balance":_vm.balance,"is-inline":_vm.isInline}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }